/**
* © 2025. The EGT Universe. All Rights Reserved.
* License: Requires ACTIVE AppArtisan Subscription.
* Generated: Auto generated by Universe App Tools.
* 
* Namespace: scripto
* Filename: elements
* Description: All UAT Elements
*/

var registry = require("../uam/registry.js");
var _myRegistry = registry("uam.includes.elements");

var $ = {};
$.ua = {};
$.ua.a = {};
$.ua.a.conic = require("../uat/src/animations/ua.a.conic.js");

_myRegistry.add($.ua.a.conic);
$.ua.a.count = require("../uat/src/animations/ua.a.count.js");

_myRegistry.add($.ua.a.count);
$.ua.a.fade50 = require("../uat/src/animations/ua.a.fade50.js");

_myRegistry.add($.ua.a.fade50);
$.ua.a.typeon = require("../uat/src/animations/ua.a.typeon.js");

_myRegistry.add($.ua.a.typeon);
$.chart = {};
$.chart.js = require("../uat/src/elements/chart.js.js");

_myRegistry.add($.chart.js);
$.checkout = {};
$.checkout.preview = require("../uat/src/elements/checkout.preview.js");

_myRegistry.add($.checkout.preview);
$.email = {};
$.email.button = require("../uat/src/elements/email.button.js");

_myRegistry.add($.email.button);
$.email.card = require("../uat/src/elements/email.card.js");

_myRegistry.add($.email.card);
$.email.code = require("../uat/src/elements/email.code.js");

_myRegistry.add($.email.code);
$.email.divider = require("../uat/src/elements/email.divider.js");

_myRegistry.add($.email.divider);
$.email.footer = require("../uat/src/elements/email.footer.js");

_myRegistry.add($.email.footer);
$.email.greeting = require("../uat/src/elements/email.greeting.js");

_myRegistry.add($.email.greeting);
$.email.header = require("../uat/src/elements/email.header.js");

_myRegistry.add($.email.header);
$.email.image = require("../uat/src/elements/email.image.js");

_myRegistry.add($.email.image);
$.email.list = require("../uat/src/elements/email.list.js");

_myRegistry.add($.email.list);
$.email.role = {};
$.email.role.list = require("../uat/src/elements/email.role.list.js");

_myRegistry.add($.email.role.list);
$.email.section = require("../uat/src/elements/email.section.js");

_myRegistry.add($.email.section);
$.email.security = require("../uat/src/elements/email.security.js");

_myRegistry.add($.email.security);
$.email.spacer = require("../uat/src/elements/email.spacer.js");

_myRegistry.add($.email.spacer);
$.email.text = require("../uat/src/elements/email.text.js");

_myRegistry.add($.email.text);
$.email.uajson = require("../uat/src/elements/email.uajson.js");

_myRegistry.add($.email.uajson);
$.email.unsubscribe = require("../uat/src/elements/email.unsubscribe.js");

_myRegistry.add($.email.unsubscribe);
$.home = {};
$.home.flashshow = require("../uat/src/elements/home.flashshow.js");

_myRegistry.add($.home.flashshow);
$.lottie = {};
$.lottie.dot = require("../uat/src/elements/lottie.dot.js");

_myRegistry.add($.lottie.dot);
$.pages = {};
$.pages.album = require("../uat/src/elements/pages.album.js");

_myRegistry.add($.pages.album);
$.pages.author = require("../uat/src/elements/pages.author.profile.js");

_myRegistry.add($.pages.author);
$.pages.blogindex = require("../uat/src/elements/pages.blog.index.js");

_myRegistry.add($.pages.blogindex);
$.pages.blog = require("../uat/src/elements/pages.blog.js");

_myRegistry.add($.pages.blog);
$.pages.blog.post = require("../uat/src/elements/pages.blog.post.js");

_myRegistry.add($.pages.blog.post);
$.pages.documentation = require("../uat/src/elements/pages.documentation.js");

_myRegistry.add($.pages.documentation);
$.pages.event = require("../uat/src/elements/pages.event.js");

_myRegistry.add($.pages.event);
$.pages.landing = require("../uat/src/elements/pages.landing.js");

_myRegistry.add($.pages.landing);
$.pages.meta = require("../uat/src/elements/pages.meta.js");

_myRegistry.add($.pages.meta);
$.pages.news = require("../uat/src/elements/pages.news.article.js");

_myRegistry.add($.pages.news);
$.pages.page = require("../uat/src/elements/pages.page.js");

_myRegistry.add($.pages.page);
$.pages.podcastepisode = require("../uat/src/elements/pages.podcast.episode.js");

_myRegistry.add($.pages.podcastepisode);
$.pages.podcast = require("../uat/src/elements/pages.podcast.js");

_myRegistry.add($.pages.podcast);
$.preview = {};
$.preview.album = require("../uat/src/elements/pages.preview.album.js");

_myRegistry.add($.preview.album);
$.preview.author = require("../uat/src/elements/pages.preview.author.profile.js");

_myRegistry.add($.preview.author);
$.preview.blogindex = require("../uat/src/elements/pages.preview.blog.index.js");

_myRegistry.add($.preview.blogindex);
$.preview.blog = require("../uat/src/elements/pages.preview.blog.post.js");

_myRegistry.add($.preview.blog);
$.preview.documentation = require("../uat/src/elements/pages.preview.documentation.js");

_myRegistry.add($.preview.documentation);
$.preview.event = require("../uat/src/elements/pages.preview.event.js");

_myRegistry.add($.preview.event);
$.pages.preview = require("../uat/src/elements/pages.preview.js");

_myRegistry.add($.pages.preview);
$.preview.landing = require("../uat/src/elements/pages.preview.landing.js");

_myRegistry.add($.preview.landing);
$.preview.news = require("../uat/src/elements/pages.preview.news.article.js");

_myRegistry.add($.preview.news);
$.preview.podcastepisode = require("../uat/src/elements/pages.preview.podcast.episode.js");

_myRegistry.add($.preview.podcastepisode);
$.preview.podcast = require("../uat/src/elements/pages.preview.podcast.js");

_myRegistry.add($.preview.podcast);
$.preview.product = require("../uat/src/elements/pages.preview.product.js");

_myRegistry.add($.preview.product);
$.preview.recipe = require("../uat/src/elements/pages.preview.recipe.js");

_myRegistry.add($.preview.recipe);
$.preview.releasenote = require("../uat/src/elements/pages.preview.release.note.js");

_myRegistry.add($.preview.releasenote);
$.preview.song = require("../uat/src/elements/pages.preview.song.js");

_myRegistry.add($.preview.song);
$.preview.staff = require("../uat/src/elements/pages.preview.staff.profile.js");

_myRegistry.add($.preview.staff);
$.preview.standard = require("../uat/src/elements/pages.preview.standard.js");

_myRegistry.add($.preview.standard);
$.preview.video = require("../uat/src/elements/pages.preview.video.js");

_myRegistry.add($.preview.video);
$.preview.web = require("../uat/src/elements/pages.preview.web.page.js");

_myRegistry.add($.preview.web);
$.pages.product = require("../uat/src/elements/pages.product.js");

_myRegistry.add($.pages.product);
$.pages.recipe = require("../uat/src/elements/pages.recipe.js");

_myRegistry.add($.pages.recipe);
$.pages.releasenote = require("../uat/src/elements/pages.release.note.js");

_myRegistry.add($.pages.releasenote);
$.pages.song = require("../uat/src/elements/pages.song.js");

_myRegistry.add($.pages.song);
$.pages.staff = require("../uat/src/elements/pages.staff.profile.js");

_myRegistry.add($.pages.staff);
$.pages.standard = require("../uat/src/elements/pages.standard.js");

_myRegistry.add($.pages.standard);
$.pages.video = require("../uat/src/elements/pages.video.js");

_myRegistry.add($.pages.video);
$.pages.web = require("../uat/src/elements/pages.web.page.js");

_myRegistry.add($.pages.web);
$.special = {};
$.special.body = require("../uat/src/elements/special.body.js");

_myRegistry.add($.special.body);
$.ua.a.incenter = require("../uat/src/elements/ua.a.incenter.js");

_myRegistry.add($.ua.a.incenter);
$.ua.access = require("../uat/src/elements/ua.access.js");

_myRegistry.add($.ua.access);
$.ua.accordion = require("../uat/src/elements/ua.accordion.js");

_myRegistry.add($.ua.accordion);
$.ua.address = require("../uat/src/elements/ua.address.js");

_myRegistry.add($.ua.address);
$.ua.address.list = require("../uat/src/elements/ua.address.list.js");

_myRegistry.add($.ua.address.list);
$.ua.address.show = require("../uat/src/elements/ua.address.show.js");

_myRegistry.add($.ua.address.show);
$.ua.agreement = require("../uat/src/elements/ua.agreement.js");

_myRegistry.add($.ua.agreement);
$.ua.alert = require("../uat/src/elements/ua.alert.js");

_myRegistry.add($.ua.alert);
$.ua.appbar = require("../uat/src/elements/ua.appbar.js");

_myRegistry.add($.ua.appbar);
$.ua.attr = {};
$.ua.attr.data = {};
$.ua.attr.data.goto = require("../uat/src/elements/ua.attr.data.goto.js");

_myRegistry.add($.ua.attr.data.goto);
$.ua.breadcrumb = require("../uat/src/elements/ua.breadcrumb.js");

_myRegistry.add($.ua.breadcrumb);
$.ua.button = {};
$.ua.button.toggle = require("../uat/src/elements/ua.button.toggle.js");

_myRegistry.add($.ua.button.toggle);
$.ua.card = {};
$.ua.card.simple = require("../uat/src/elements/ua.card.simple.js");

_myRegistry.add($.ua.card.simple);
$.ua.carousel = require("../uat/src/elements/ua.carousel.js");

_myRegistry.add($.ua.carousel);
$.ua.checkbox = require("../uat/src/elements/ua.checkbox.js");

_myRegistry.add($.ua.checkbox);
$.ua.code = require("../uat/src/elements/ua.code.js");

_myRegistry.add($.ua.code);
$.ua.collection = {};
$.ua.collection.order = require("../uat/src/elements/ua.collection.order.js");

_myRegistry.add($.ua.collection.order);
$.ua.dashboard = {};
$.ua.dashboard.item = require("../uat/src/elements/ua.dashboard.item.js");

_myRegistry.add($.ua.dashboard.item);
$.ua.dashboard.list = require("../uat/src/elements/ua.dashboard.list.js");

_myRegistry.add($.ua.dashboard.list);
$.ua.dashboard.sidebar = require("../uat/src/elements/ua.dashboard.sidebar.js");

_myRegistry.add($.ua.dashboard.sidebar);
$.ua.devmode = require("../uat/src/elements/ua.devmode.js");

_myRegistry.add($.ua.devmode);
$.ua.dialog = {};
$.ua.dialog.getdirections = require("../uat/src/elements/ua.dialog.getdirections.js");

_myRegistry.add($.ua.dialog.getdirections);
$.ua.dialog = require("../uat/src/elements/ua.dialog.js");

_myRegistry.add($.ua.dialog);
$.ua.doc = {};
$.ua.doc.email = require("../uat/src/elements/ua.doc.email.js");

_myRegistry.add($.ua.doc.email);
$.ua.doc.simple = require("../uat/src/elements/ua.doc.simple.js");

_myRegistry.add($.ua.doc.simple);
$.ua.element = {};
$.ua.element.error = require("../uat/src/elements/ua.element.error.js");

_myRegistry.add($.ua.element.error);
$.ua.element.placeholder = require("../uat/src/elements/ua.element.placeholder.js");

_myRegistry.add($.ua.element.placeholder);
$.ua.element.scripts = require("../uat/src/elements/ua.element.scripts.js");

_myRegistry.add($.ua.element.scripts);
$.ua.element.servernotsupported = require("../uat/src/elements/ua.element.serverNotSupported.js");

_myRegistry.add($.ua.element.servernotsupported);
$.ua.element.validation = {};
$.ua.element.validation.error = require("../uat/src/elements/ua.element.validation.error.js");

_myRegistry.add($.ua.element.validation.error);
$.ua.error = {};
$.ua.error.stacktrace = {};
$.ua.error.stacktrace.line = require("../uat/src/elements/ua.error.stacktrace.line.js");

_myRegistry.add($.ua.error.stacktrace.line);
$.ua.fields = {};
$.ua.fields.type = {};
$.ua.fields.type.select = require("../uat/src/elements/ua.fields.type.select.js");

_myRegistry.add($.ua.fields.type.select);
$.ua.file = {};
$.ua.file.preview = require("../uat/src/elements/ua.file.preview.js");

_myRegistry.add($.ua.file.preview);
$.ua.file.upload = require("../uat/src/elements/ua.file.upload.js");

_myRegistry.add($.ua.file.upload);
$.ua.filter = require("../uat/src/elements/ua.filter.js");

_myRegistry.add($.ua.filter);
$.ua.footer = require("../uat/src/elements/ua.footer.js");

_myRegistry.add($.ua.footer);
$.ua.footnote = require("../uat/src/elements/ua.footnote.js");

_myRegistry.add($.ua.footnote);
$.ua.footnotes = require("../uat/src/elements/ua.footnotes.js");

_myRegistry.add($.ua.footnotes);
$.ua.fs = {};
$.ua.fs.center = require("../uat/src/elements/ua.fs.center.js");

_myRegistry.add($.ua.fs.center);
$.ua.fs.col = require("../uat/src/elements/ua.fs.col.js");

_myRegistry.add($.ua.fs.col);
$.ua.fs.image = require("../uat/src/elements/ua.fs.image.js");

_myRegistry.add($.ua.fs.image);
$.ua.fs.module = require("../uat/src/elements/ua.fs.module.js");

_myRegistry.add($.ua.fs.module);
$.ua.fs.scrollup = require("../uat/src/elements/ua.fs.scrollup.js");

_myRegistry.add($.ua.fs.scrollup);
$.ua.fs.sidebyside = {};
$.ua.fs.sidebyside.image = require("../uat/src/elements/ua.fs.sidebyside.image.js");

_myRegistry.add($.ua.fs.sidebyside.image);
$.ua.fs.sidebyside.sticky = require("../uat/src/elements/ua.fs.sidebyside.sticky.js");

_myRegistry.add($.ua.fs.sidebyside.sticky);
$.ua.fs.simple = require("../uat/src/elements/ua.fs.simple.js");

_myRegistry.add($.ua.fs.simple);
$.ua.fs.video = require("../uat/src/elements/ua.fs.video.js");

_myRegistry.add($.ua.fs.video);
$.ua.getdirections = require("../uat/src/elements/ua.getdirections.js");

_myRegistry.add($.ua.getdirections);
$.ua.hcard = {};
$.ua.hcard.simple = require("../uat/src/elements/ua.hcard.simple.js");

_myRegistry.add($.ua.hcard.simple);
$.ua.header = require("../uat/src/elements/ua.header.js");

_myRegistry.add($.ua.header);
$.ua.input = require("../uat/src/elements/ua.input.js");

_myRegistry.add($.ua.input);
$.ua.list = {};
$.ua.list.item = require("../uat/src/elements/ua.list.item.js");

_myRegistry.add($.ua.list.item);
$.ua.list = require("../uat/src/elements/ua.list.js");

_myRegistry.add($.ua.list);
$.ua.magic = {};
$.ua.magic.glow = require("../uat/src/elements/ua.magic.glow.js");

_myRegistry.add($.ua.magic.glow);
$.ua.marquee = require("../uat/src/elements/ua.marquee.js");

_myRegistry.add($.ua.marquee);
$.ua.nav = require("../uat/src/elements/ua.nav.js");

_myRegistry.add($.ua.nav);
$.ua.navbar = {};
$.ua.navbar.item = require("../uat/src/elements/ua.navbar.item.js");

_myRegistry.add($.ua.navbar.item);
$.ua.navbar = require("../uat/src/elements/ua.navbar.js");

_myRegistry.add($.ua.navbar);
$.ua.navbar.menu = require("../uat/src/elements/ua.navbar.menu.js");

_myRegistry.add($.ua.navbar.menu);
$.ua.none = require("../uat/src/elements/ua.none.js");

_myRegistry.add($.ua.none);
$.ua.notification = {};
$.ua.notification.icon = require("../uat/src/elements/ua.notification.icon.js");

_myRegistry.add($.ua.notification.icon);
$.ua.phone = require("../uat/src/elements/ua.phone.js");

_myRegistry.add($.ua.phone);
$.ua.platform = {};
$.ua.platform.video = require("../uat/src/elements/ua.platform.video.js");

_myRegistry.add($.ua.platform.video);
$.ua.preview = {};
$.ua.preview.access = require("../uat/src/elements/ua.preview.access.js");

_myRegistry.add($.ua.preview.access);
$.ua.preview.address = require("../uat/src/elements/ua.preview.address.js");

_myRegistry.add($.ua.preview.address);
$.ua.preview.agreement = require("../uat/src/elements/ua.preview.agreement.js");

_myRegistry.add($.ua.preview.agreement);
$.ua.preview.boolean = require("../uat/src/elements/ua.preview.boolean.js");

_myRegistry.add($.ua.preview.boolean);
$.ua.preview.color = require("../uat/src/elements/ua.preview.color.js");

_myRegistry.add($.ua.preview.color);
$.ua.preview.input = require("../uat/src/elements/ua.preview.input.js");

_myRegistry.add($.ua.preview.input);
$.ua.preview.json = require("../uat/src/elements/ua.preview.json.js");

_myRegistry.add($.ua.preview.json);
$.ua.preview.phone = require("../uat/src/elements/ua.preview.phone.js");

_myRegistry.add($.ua.preview.phone);
$.ua.preview.select = {};
$.ua.preview.select.multiple = require("../uat/src/elements/ua.preview.select.multiple.js");

_myRegistry.add($.ua.preview.select.multiple);
$.ua.preview.tags = require("../uat/src/elements/ua.preview.tags.js");

_myRegistry.add($.ua.preview.tags);
$.ua.preview.text = require("../uat/src/elements/ua.preview.text.js");

_myRegistry.add($.ua.preview.text);
$.ua.quick = {};
$.ua.quick.bio = require("../uat/src/elements/ua.quick.bio.js");

_myRegistry.add($.ua.quick.bio);
$.ua.random = require("../uat/src/elements/ua.random.js");

_myRegistry.add($.ua.random);
$.ua.repeater = require("../uat/src/elements/ua.repeater.js");

_myRegistry.add($.ua.repeater);
$.ua.report = {};
$.ua.report.metric = {};
$.ua.report.metric.card = require("../uat/src/elements/ua.report.metric.card.js");

_myRegistry.add($.ua.report.metric.card);
$.ua.report.panel = require("../uat/src/elements/ua.report.panel.js");

_myRegistry.add($.ua.report.panel);
$.ua.report.view = require("../uat/src/elements/ua.report.view.js");

_myRegistry.add($.ua.report.view);
$.ua.fields.schema = {};
$.ua.fields.schema.editor = require("../uat/src/elements/ua.schema.editor.js");

_myRegistry.add($.ua.fields.schema.editor);
$.ua.scroll = {};
$.ua.scroll.progress = require("../uat/src/elements/ua.scroll.progress.js");

_myRegistry.add($.ua.scroll.progress);
$.ua.scroll.totop = require("../uat/src/elements/ua.scroll.totop.js");

_myRegistry.add($.ua.scroll.totop);
$.ua.select = {};
$.ua.select.accordion = require("../uat/src/elements/ua.select.accordion.js");

_myRegistry.add($.ua.select.accordion);
$.ua.select.color = require("../uat/src/elements/ua.select.color.js");

_myRegistry.add($.ua.select.color);
$.ua.select.datalist = require("../uat/src/elements/ua.select.datalist.js");

_myRegistry.add($.ua.select.datalist);
$.ua.select.date = require("../uat/src/elements/ua.select.date.js");

_myRegistry.add($.ua.select.date);
$.ua.select.dropdown = require("../uat/src/elements/ua.select.dropdown.js");

_myRegistry.add($.ua.select.dropdown);
$.ua.select.group = require("../uat/src/elements/ua.select.group.js");

_myRegistry.add($.ua.select.group);
$.ua.select.multiple = require("../uat/src/elements/ua.select.multiple.js");

_myRegistry.add($.ua.select.multiple);
$.ua.source = require("../uat/src/elements/ua.source.js");

_myRegistry.add($.ua.source);
$.ua.switch = require("../uat/src/elements/ua.switch.js");

_myRegistry.add($.ua.switch);
$.ua.t = require("../uat/src/elements/ua.t.js");

_myRegistry.add($.ua.t);
$.ua.e = {};
$.ua.e.nav = {};
$.ua.e.nav.tabs = require("../uat/src/elements/ua.tabs.js");

_myRegistry.add($.ua.e.nav.tabs);
$.ua.tags = require("../uat/src/elements/ua.tags.js");

_myRegistry.add($.ua.tags);
$.ua.text = {};
$.ua.text.bygroup = require("../uat/src/elements/ua.text.bygroup.js");

_myRegistry.add($.ua.text.bygroup);
$.ua.toggle = require("../uat/src/elements/ua.toggle.js");

_myRegistry.add($.ua.toggle);
$.ua.ts = require("../uat/src/elements/ua.ts.js");

_myRegistry.add($.ua.ts);
$.ua.updater = require("../uat/src/elements/ua.updater.js");

_myRegistry.add($.ua.updater);
$.ua.uri = {};
$.ua.uri.selector = require("../uat/src/elements/ua.uri.selector.js");

_myRegistry.add($.ua.uri.selector);
$.ua.wizard = require("../uat/src/elements/ua.wizard.js");

_myRegistry.add($.ua.wizard);
$.hero = {};
$.hero.fs = {};
$.hero.fs.video = require("../app/elements/hero.fs.video.js");

_myRegistry.add($.hero.fs.video);
$.our = {};
$.our.story = {};
$.our.story.video = require("../app/elements/our.story.video.js");

_myRegistry.add($.our.story.video);


$._ = {
    // namespace: "our.story.video",
registry: _myRegistry,

};
module.exports = $;
